export const CURRENCIES = {
  USD: {
    code: 'USD',
    sign: '$',
  },
  AED: {
    code: 'AED',
    sign: 'Dhs.',
  },
  AFN: {
    code: 'AFN',
    sign: 'Af',
  },
  ALL: {
    code: 'ALL',
    sign: 'Lek',
  },
  AMD: {
    code: 'AMD',
    sign: 'AMD',
  },
  ANG: {
    code: 'ANG',
    sign: 'ƒ',
  },
  AOA: {
    code: 'AOA',
    sign: 'Kz',
  },
  ARS: {
    code: 'ARS',
    sign: '$',
  },
  AUD: {
    code: 'AUD',
    sign: '$',
  },
  AWG: {
    code: 'AWG',
    sign: 'Afl',
  },
  AZN: {
    code: 'AZN',
    sign: 'm.',
  },
  BAM: {
    code: 'BAM',
    sign: 'KM',
  },
  BBD: {
    code: 'BBD',
    sign: '$',
  },
  BDT: {
    code: 'BDT',
    sign: 'Tk',
  },
  BGN: {
    code: 'BGN',
    sign: 'лв',
  },
  BHD: {
    code: 'BHD',
    sign: 'BD',
  },
  BND: {
    code: 'BND',
    sign: '$',
  },
  BOB: {
    code: 'BOB',
    sign: 'Bs',
  },
  BRL: {
    code: 'BRL',
    sign: 'R$',
  },
  BSD: {
    code: 'BSD',
    sign: 'BS$',
  },
  BTN: {
    code: 'BTN',
    sign: 'Nu',
  },
  BWP: {
    code: 'BWP',
    sign: 'P',
  },
  BYR: {
    code: 'BYR',
    sign: 'Br',
  },
  BZD: {
    code: 'BZD',
    sign: 'BZ$',
  },
  CAD: {
    code: 'CAD',
    sign: '$',
  },
  CHF: {
    code: 'CHF',
    sign: 'SFr.',
  },
  CLP: {
    code: 'CLP',
    sign: '$',
  },
  CNY: {
    code: 'CNY',
    sign: '¥',
  },
  COP: {
    code: 'COP',
    sign: '$',
  },
  CRC: {
    code: 'CRC',
    sign: '₡',
  },
  CZK: {
    code: 'CZK',
    sign: 'Kč',
  },
  DKK: {
    code: 'DKK',
    sign: 'kr.',
  },
  DOP: {
    code: 'DOP',
    sign: 'RD$',
  },
  DZD: {
    code: 'DZD',
    sign: 'DA',
  },
  EGP: {
    code: 'EGP',
    sign: 'LE',
  },
  ETB: {
    code: 'ETB',
    sign: 'Br',
  },
  EUR: {
    code: 'EUR',
    sign: '€',
  },
  FJD: {
    code: 'FJD',
    sign: '$',
  },
  GBP: {
    code: 'GBP',
    sign: '£',
  },
  GEL: {
    code: 'GEL',
    sign: 'GEL',
  },
  GHS: {
    code: 'GHS',
    sign: 'GH₵',
  },
  GMD: {
    code: 'GMD',
    sign: 'D',
  },
  GTQ: {
    code: 'GTQ',
    sign: 'Q',
  },
  GYD: {
    code: 'GYD',
    sign: 'G$',
  },
  HKD: {
    code: 'HKD',
    sign: '$',
  },
  HNL: {
    code: 'HNL',
    sign: 'L',
  },
  HRK: {
    code: 'HRK',
    sign: 'kn',
  },
  HUF: {
    code: 'HUF',
    sign: 'Ft',
  },
  IDR: {
    code: 'IDR',
    sign: 'Rp',
  },
  ILS: {
    code: 'ILS',
    sign: 'NIS',
  },
  INR: {
    code: 'INR',
    sign: '₹',
  },
  ISK: {
    code: 'ISK',
    sign: 'kr',
  },
  JEP: {
    code: 'JEP',
    sign: '£',
  },
  JMD: {
    code: 'JMD',
    sign: '$',
  },
  JOD: {
    code: 'JOD',
    sign: 'JD',
  },
  JPY: {
    code: 'JPY',
    sign: '¥',
  },
  KES: {
    code: 'KES',
    sign: 'KSh',
  },
  KGS: {
    code: 'KGS',
    sign: 'лв',
  },
  KHR: {
    code: 'KHR',
    sign: 'KHR',
  },
  KRW: {
    code: 'KRW',
    sign: '₩',
  },
  KWD: {
    code: 'KWD',
    sign: 'KD',
  },
  KYD: {
    code: 'KYD',
    sign: '$',
  },
  KZT: {
    code: 'KZT',
    sign: 'KZT',
  },
  LBP: {
    code: 'LBP',
    sign: 'L£',
  },
  LKR: {
    code: 'LKR',
    sign: 'Rs',
  },
  LTL: {
    code: 'LTL',
    sign: 'Lt',
  },
  LVL: {
    code: 'LVL',
    sign: 'Ls',
  },
  MAD: {
    code: 'MAD',
    sign: 'dh',
  },
  MDL: {
    code: 'MDL',
    sign: 'MDL',
  },
  MGA: {
    code: 'MGA',
    sign: 'Ar',
  },
  MKD: {
    code: 'MKD',
    sign: 'ден',
  },
  MMK: {
    code: 'MMK',
    sign: 'K',
  },
  MNT: {
    code: 'MNT',
    sign: '₮',
  },
  MOP: {
    code: 'MOP',
    sign: 'MOP$',
  },
  MUR: {
    code: 'MUR',
    sign: 'Rs',
  },
  MVR: {
    code: 'MVR',
    sign: 'Rf',
  },
  MXN: {
    code: 'MXN',
    sign: '$',
  },
  MYR: {
    code: 'MYR',
    sign: 'RM MYR',
  },
  MZN: {
    code: 'MZN',
    sign: 'Mt',
  },
  NAD: {
    code: 'NAD',
    sign: 'N$',
  },
  NGN: {
    code: 'NGN',
    sign: '₦',
  },
  NIO: {
    code: 'NIO',
    sign: 'C$',
  },
  NOK: {
    code: 'NOK',
    sign: 'kr',
  },
  NPR: {
    code: 'NPR',
    sign: 'Rs',
  },
  NZD: {
    code: 'NZD',
    sign: '$',
  },
  OMR: {
    code: 'OMR',
    sign: 'OMR',
  },
  PEN: {
    code: 'PEN',
    sign: 'S/.',
  },
  PGK: {
    code: 'PGK',
    sign: 'K',
  },
  PHP: {
    code: 'PHP',
    sign: '₱',
  },
  PKR: {
    code: 'PKR',
    sign: 'Rs.',
  },
  PLN: {
    code: 'PLN',
    sign: 'zl',
  },
  PYG: {
    code: 'PYG',
    sign: 'Gs.',
  },
  QAR: {
    code: 'QAR',
    sign: 'QAR',
  },
  RON: {
    code: 'RON',
    sign: 'lei',
  },
  RSD: {
    code: 'RSD',
    sign: 'RSD',
  },
  RUB: {
    code: 'RUB',
    sign: 'руб',
  },
  RWF: {
    code: 'RWF',
    sign: 'RF',
  },
  SAR: {
    code: 'SAR',
    sign: 'SR',
  },
  SCR: {
    code: 'SCR',
    sign: 'Rs',
  },
  SEK: {
    code: 'SEK',
    sign: 'kr',
  },
  SGD: {
    code: 'SGD',
    sign: '$',
  },
  STD: {
    code: 'STD',
    sign: 'Db',
  },
  SYP: {
    code: 'SYP',
    sign: 'S£',
  },
  THB: {
    code: 'THB',
    sign: '฿',
  },
  TND: {
    code: 'TND',
    sign: 'DT',
  },
  TRY: {
    code: 'TRY',
    sign: 'TL',
  },
  TTD: {
    code: 'TTD',
    sign: '$',
  },
  TWD: {
    code: 'TWD',
    sign: '$',
  },
  TZS: {
    code: 'TZS',
    sign: 'TZS',
  },
  UAH: {
    code: 'UAH',
    sign: '₴',
  },
  UGX: {
    code: 'UGX',
    sign: 'Ush',
  },
  UYU: {
    code: 'UYU',
    sign: '$',
  },
  VEF: {
    code: 'VEF',
    sign: 'Bs.',
  },
  VND: {
    code: 'VND',
    sign: '₫',
  },
  VUV: {
    code: 'VUV',
    sign: '$',
  },
  WST: {
    code: 'WST',
    sign: 'WS$',
  },
  XAF: {
    code: 'XAF',
    sign: 'FCFA',
  },
  XBT: {
    code: 'XBT',
    sign: 'BTC',
  },
  XCD: {
    code: 'XCD',
    sign: '$',
  },
  XOF: {
    code: 'XOF',
    sign: 'CFA',
  },
  XPF: {
    code: 'XPF',
    sign: 'XPF',
  },
  ZAR: {
    code: 'ZAR',
    sign: 'R',
  },
  ZMW: {
    code: 'ZMW',
    sign: 'K',
  },
} as const;

export type CurrencyCode = keyof typeof CURRENCIES;
